import React from 'react';
import { HashRouter } from 'react-router-dom';

import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import 'bootswatch/dist/flatly/bootstrap.css';
import '../styles/custom.css';
import '../styles/shell.css';
import '../styles/menu-typography.css';
import '../styles/button-theme.css';
import '../styles/form-actions.css';
import '../styles/themes.css';
import '../styles/theme-picker.css';

import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '../store/store';

import Header from '../components/header';
import Body from '../components/body';

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <HashRouter>
          <Header />
          <Body />
          <ToastContainer autoClose={3000} className="toast-container"  zIndex={9999}/>
        </HashRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
